module.exports = __webpack_public_path__ + "static/media/flag_sa.cef72960.png";